import React, { Component } from 'react';

class GalleryCarousel extends Component{
  render() {
    return(
<div>
<div class="jumbotron">
<div class="container">
  ...
</div>
</div>
</div>
    )
   }
};

export default GalleryCarousel;


// WEBPACK FOOTER //
// ./src/components/Gallery/GalleryCarousel.js